const PALETTE = {
	red: {
		100: '#CC0000',
		200: '#FDF4F4',
	},

	orange: {
		50: '#F7F1E8',
		100: '#DE5000',
		200: '#EA5400',
		300: '#FF6C19',
	},

	gray: {
		0: '#DDDDDD',
		100: '#999999',
		200: '#666666',
		300: '#333333',
		400: '#313131',
	},

	white: {
		0: '#FAFAFA',
		100: '#FFFFFF',
		150: '#EEEEEE',
		170: '#EFEFEF',
		200: '#E0E0E0',
	},

	blue: '#448EF8',
	navy: '#003E53',
	navyHover: '#015977',
	ivory: '#F7F1E8',
	black: '#111111',
};

const FONT_SIZE = {
	xxs: '6px',
	xs: '8px',
	s: '10px',
	ms: '12px',
	m: '14px',
	ml: '16px',
	l: '18px',
	xl: '20px',
	xxl: '22px',
	j: '24px',
	xj: '36px',
};

// light 300
// regular 400
// medium 500
// semi-bold 600

const theme = {
	PALETTE,
	FONT_SIZE,
};

export default theme;
